import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.dashboard.title',
    defaultMessage: 'Dashboard',
    description: 'title of the dashboard page',
  },
  noProxies: {
    title: {
      id: 'pages.dashboard.noProxies.title',
      defaultMessage: 'Create your first Quicq proxy',
      description: 'title of the dashboard page when no proxies were found',
    },
    description: {
      id: 'pages.dashboard.noProxies.description',
      defaultMessage:
        "You haven't created a Quicq proxy yet. Go to the proxies page and create your first Quicq proxy.",
      description: 'description of the dashboard page when no proxies were found',
    },
    actions: {
      proxiesPage: {
        id: 'pages.dashboard.noProxies.actions.proxiesPage',
        defaultMessage: 'Proxies page',
        description: 'title of the dashboard page when no proxies were found',
      },
    },
  },
};

export default defineMessages(translations);
